import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (!this.hasUrlValue) return
    if (window.matchMedia("(min-width: 1280px)").matches) return
    if (window.matchMedia("(pointer: fine)").matches) return

    const target = new URL(this.urlValue, window.location.origin)
    if (window.location.pathname === target.pathname) return

    window.Turbo.visit(this.urlValue, { action: "replace" })
  }
}
